// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {

	// Update Buttons 
	updateButtons('.btn, .signup-btn')

	//Burger Menu
	const burger_CTAS  = document.querySelectorAll("[data-ctaburger]");
	const burger_Content = document.querySelector("[data-menuburger]");

	burger_CTAS.forEach(currentItem => {
		currentItem.addEventListener('click', (e) =>{
			e.preventDefault();
			burger_Content.classList.toggle("open");
			document.body.classList.toggle("no-scroll");
		});
	});
	
	//Desktop Subnavigation
	if (window.innerWidth >= 900) {
    const menuItems = document.querySelectorAll(".header #privary-navigation li:has(.submenu)");
    const galleryImages = document.querySelectorAll("[data-link]");

    const findMatchingImage = linkText => {
        return Array.from(galleryImages).find(img => img.dataset.link === linkText.trim());
    };

		const updateSubmenuImage = (imageElement, matchingImage) => {
			if (matchingImage) {
					const newSrc = matchingImage.src;
					const newAlt = matchingImage.alt;
					if (imageElement.src !== newSrc) {
							imageElement.classList.remove("visible");

							setTimeout(() => {
									imageElement.src = newSrc;
									imageElement.alt = newAlt;
									imageElement.classList.add("visible");
							}, 200);
					}
			}
		};

    menuItems.forEach(itemNav => {
        const mainLink = itemNav.querySelector("a");
        const submenuList = mainLink.nextElementSibling;

        const overviewLink = document.createElement("a");
        overviewLink.textContent = "Overview";
        overviewLink.href = mainLink.href;
        overviewLink.dataset.link = mainLink.textContent.trim();
        overviewLink.classList.add("overview-link");
		overviewLink.setAttribute('aria-label',`Overview - ${overviewLink.dataset.link}`);

        const overviewItem = document.createElement("li");
        overviewItem.classList.add("privary-navigation__item", "primary-nav-overview");

		/** Validation to remove repeated subnav links **/

		const submenuAnchors = submenuList.querySelectorAll('li a');
		const submenuAnchorsHref = [];

		submenuAnchors.forEach(anchor => {
			submenuAnchorsHref.push(anchor.href);
		})

		if (submenuAnchorsHref.includes(overviewLink.href)) {
			console.log('Repeated overview link');
		} else {
			overviewItem.appendChild(overviewLink);
			submenuList.prepend(overviewItem);
		}
        
        itemNav.innerHTML = `
            ${mainLink.outerHTML}
            <div class="privary-submenu">
                <div class="privary-submenu__container">
                    <div class="privary-submenu__left">
                        ${submenuList.outerHTML}
                    </div>
                    <div class="privary-submenu__right">
                        <img src="" alt="custom image">
                    </div>
                </div>
            </div>
        `;

        const submenuImage = itemNav.querySelector(".privary-submenu__right img");
		const subMenus = itemNav.querySelectorAll(".privary-navigation__submenu");
        const submenuLinks = itemNav.querySelectorAll(".privary-navigation__submenu a");
        const overviewImage = findMatchingImage(mainLink.textContent);

        updateSubmenuImage(submenuImage, overviewImage);

        submenuLinks.forEach(link => {
            link.addEventListener("mouseenter", () => {
                const linkText = link.textContent.trim();
                const matchingImage = linkText === "Overview" ? overviewImage : findMatchingImage(linkText);
                updateSubmenuImage(submenuImage, matchingImage);
            });
        });
		
		document.addEventListener("DOMContentLoaded", () =>{
			subMenus.forEach(subMenu =>{
				if (subMenu.hasAttribute("aria-hidden")){
					subMenu.removeAttribute("aria-hidden");
				}
			});
		})
    });
}
	if (window.innerWidth <= 900) {
		const menu_Items = document.querySelectorAll(".burger-menu .burger-menu__nav li:has(.submenu)");
		let prevMenuItem;

		menu_Items.forEach(element => {

			// active for link generate in js
			const Main_Link = element.querySelector("a");
			const Link_url = Main_Link.href;
			const newListItem = `
			<li class="privary-navigation__item">
				<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">overview</a>
			</li>`;

			//Main_Link.nextElementSibling.insertAdjacentHTML("afterbegin", newListItem);

			// active for link generate in js
			if (Main_Link.classList.contains("active")) {
				Main_Link.nextElementSibling.querySelector("a").classList.add("active");
			}

			if ([...Main_Link.nextElementSibling.querySelectorAll("a")].some(item => item.classList.contains("active"))) {
				Main_Link.nextElementSibling.classList.add("active")
			}

			Main_Link.addEventListener('click', (e) => {
				e.preventDefault();
				if (prevMenuItem && prevMenuItem != e.target.nextElementSibling) prevMenuItem.classList.remove('active');
				e.target.nextElementSibling.classList.toggle("active");
				prevMenuItem = e.target.nextElementSibling;
			});
		});
	}

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(".email-signup .input input")
	if (allInputsSignUp) {
		allInputsSignUp.forEach(input => {
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		});
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field');

		for (let j = 0; j < allffields.length; j++) {

			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
		}
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll("[data-accodion] .tab-js");
	normal_accordion.forEach( (item, i) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});

		if (i ==0) item.click()
	});

	//accordion Functionality mobile big slider
	if (window.innerWidth <= 900) {
		const bigAccordions = document.querySelectorAll(".big-slider, .menus-block");

		bigAccordions.forEach(accordion => {
				const tabs = accordion.querySelectorAll("[data-accordion]");

				tabs.forEach((tab, index) => {
						const content = tab.nextElementSibling;
						content.style.height = "0";

						tab.addEventListener("click", () => {
								tabs.forEach(otherTab => {
										const otherContent = otherTab.nextElementSibling;
										otherTab.classList.remove("active");
										otherContent.style.height = "0";
								});

								if (!tab.classList.contains("active")) {
										tab.classList.add("active");
										content.style.height = `${content.scrollHeight}px`;
								} else {
										tab.classList.remove("active");
										content.style.height = "0";
								}
						});

						if (index === 0) {
								tab.click();
						}
				});
		});
	}

	//lightbox Menus Tabs
	document.querySelectorAll(".menus-block__lightbox").forEach(lightbox => {
			const tabs = lightbox.querySelectorAll("[data-tab]");
			const menus = lightbox.querySelectorAll("[data-menu]");
			tabs.forEach((tab , i) => {
					tab.addEventListener("click", (event) => {
							tabs.forEach(t => t.classList.remove("active"));
							menus.forEach(menu => menu.classList.remove("active"));
							event.target.classList.add("active");
							const targetMenu = lightbox.querySelector(`[data-menu="${event.target.dataset.tab}"]`);
							if (targetMenu) {
									targetMenu.classList.add("active");
							}
					});
					if (i ==0) tab.click()
			});
	});

})();

function updateButtons(selector) {
	const buttons = document.querySelectorAll(selector)

	buttons.forEach((btn) => {
		const svgContent = `
					<svg xmlns="http://www.w3.org/2000/svg"  width="20.48" height="6" viewBox="0 0 20.48 6" class="btn-svg">
						<polygon points="20.48 3 15.48 0 15.48 2.5 0 2.5 0 3.5 15.48 3.5 15.48 6 20.48 3" />
					</svg>`
		const spanContent = `<span class="btn-text">${btn.textContent}</span>`
		btn.innerHTML = `${spanContent}${svgContent}`
	})
}


function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300;
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {

			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}

//class for scroll
let classtoscroll = document.querySelectorAll(".scroll-js , .btn-scroll");
if (classtoscroll) {
	classtoscroll.forEach(item => {
		item.addEventListener("click", (e) => {
			e.preventDefault();
			let sectiongoto = e.target.hash.split("#")[1];
			animateTo(sectiongoto)
			if (document.querySelector(".sub-menu__hold").classList.contains("open")) {
				document.querySelector(".sub-menu__hold").classList.remove("open")
			}
		});
	});
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if (allsublinks.length > 1) {
	allsublinks.forEach(ele => {
		ele.addEventListener('click', function (ev) {
			if (ele.classList.contains('active')) {
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
} else if (submenuHold.length > 0) {
	submenuHold[0].classList.add('hidden');
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
	const menu = document.querySelector('.burger-menu');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('.burger-menu__nav a, .burger-menu #secondary-navigation a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});

/** ADA - Add aria-label to Footer Navigation **/
document.addEventListener("DOMContentLoaded", function () {
	const secondaryNavFooter = document.querySelector(".footer #secondary-nav");

	if (secondaryNavFooter) {
		secondaryNavFooter.setAttribute("aria-label", "Secondary Footer Navigation");
	}
});

/** ADA fix: remove invalid aria-labelledby from <textarea> fields **/
document.addEventListener("DOMContentLoaded", function () {
	const selectors = [
		"#weddingrfpformsubmission-form .field_4007_8 textarea",
		"#contactusformsubmission-form .field_4011_4 textarea",
		"#planyoureventrfpsubmission-form .field_4006_9 textarea"
	];

	selectors.forEach(function(selector) {
		const field = document.querySelector(selector);
		if (field) {
			field.removeAttribute("aria-labelledby");
		}
	});
});
